export default "__VITE_ASSET__CIUVyYLj__"